import { joinApiUrl } from "./config.js";
import { getCustomerApiErrorMessage } from "../utils/customerMessages.js";

export class CologuardApiError extends Error {
  constructor(message, { status = 0, code = "", details = null } = {}) {
    super(message);
    this.name = "CologuardApiError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export async function requestJson({
  baseUrl,
  path,
  method = "GET",
  accessToken = "",
  query,
  body,
  signal,
  fallbackMessage = "The Cologuard request failed.",
}) {
  const url = new URL(joinApiUrl(baseUrl, path));
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value) !== "") {
      url.searchParams.set(key, String(value));
    }
  });

  const headers = { Accept: "application/json" };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  let response;
  try {
    response = await fetch(url.toString(), {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new CologuardApiError(
      "Cologuard is temporarily unavailable. Check your connection and try again.",
      { details: error }
    );
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    console.error("Cologuard request failed", {
      method,
      url: url.toString(),
      status: response.status,
      technicalMessage: data.error || data.message || "No response message",
    });
    throw new CologuardApiError(getCustomerApiErrorMessage({
      status: response.status,
      data,
      fallbackMessage,
    }), {
      status: response.status,
      code: data.code || "",
      details: data,
    });
  }

  return data;
}
